// src/components/ScheduleCard.jsx
import React from 'react';
import './ScheduleCard.css';

const ScheduleCard = ({ name, openTime, closeTime }) => {
  return (
    <div className="schedule-card">
      <h3 className="schedule-name">{name}</h3>
      <div className="schedule-times">
        <div className="time-group">
          <span className="time-label">Time Open:</span>
          <span className="time-value">{openTime}</span>
        </div>
        <div className="time-group">
          <span className="time-label">Time Close:</span>
          <span className="time-value">{closeTime}</span>
        </div>
      </div>
    </div>
  );
};

export default ScheduleCard;